/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getproizvodjacPartnerDropdown} from '../../api'
import {Option} from '../../models/Sektor'

// proizvodjacPartnerDropdown Props for the component
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
  disabled?: boolean
}

const ProizvodjacPartnerDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
    disabled
}) => {
  const [proizvodjacPartnerDropdown, setProizvodjacPartnerDropdown] = useState<Array<Option>>([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getproizvodjacPartnerDropdown()
        setProizvodjacPartnerDropdown(mapData(response.data))
      } catch (error) {
        console.error('Error fetching Proizvodjac Partner dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={proizvodjacPartnerDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'proizvodjacPartnerDropdown'}
      errors={errors}
      placeholder='Odaberi Proizvodjaca'
      touched={touched}
      disabled={!!disabled}
    />
  )
}

export default ProizvodjacPartnerDropdown
